import Cell from "../gameUtil/Base/Cell";
import Reel from "../gameUtil/Base/Reel";
import FreeSpinReel from "../gameUtil/Free/FreeSpinReel";
import FreeSpinCell from "../gameUtil/Free/FreeSpinCell";
import FontConfig from "../config/FontConfig";
import Utils from "../utils/Utils";
import ResourcesDispatcher from "../config/ResourcesDispatcher";
import LinkReelVertical from "../gameUtil/Link/LinkReelVertical";
import LinkReelRotation from "../gameUtil/Link/LinkReelRotation";
import { LinkReel } from "..";
import ReelStatic from "../gameUtil/Base/ReelStatic";
import ReelDynamic from "../gameUtil/Base/ReelDynamic";
import FreeSpinReelStatic from "../gameUtil/Free/FreeSpinReelStatic";
import FreeSpinReelDynamic from "../gameUtil/Free/FreeSpinReelDynamic";

(window as any).isButtonSpinning = false;


export default class CreationManager{
    
    //CREAZIONE RULLI
    static createReels(scene: any, orientation: any, type: string, expanding: boolean): Reel[] {

        let reels: Reel[] = [];
        const reelsPosition = ResourcesDispatcher.GAME_CONSTANTS.reelsPosition

        let ReelClass: any;

        if(type === "static") {
            ReelClass = ReelStatic;
        } else if (type === "dynamic") {
            ReelClass = ReelDynamic;
        }

        for (let i = 0; i < ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_REELS; i++) {
            const reel = new ReelClass(scene, reelsPosition[i].x, reelsPosition[i].y, i, orientation, expanding);
            reels.push(reel);

            // Aggiungi i rulli ai container corretti
            scene.layerManager.gameAreaLayer.baseSymbolsContainer.add(reel.getContainer());
            scene.layerManager.gameAreaLayer.overGridContainer.add(reel.getAnimationsContainer());
        }

        return reels;
    }

    //CREAZIONE CELLE
    static createCells(scene: any, reelAssociate: any, container: any) : { cells: Cell[]; cellPositions: any[] } {
        const cells: Cell[] = [];
        const numOfCells = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_CELLS_PER_REEL + ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_CELLS_PER_REEL;
        const cellsPosition = Utils.generateCellPositions(numOfCells, ResourcesDispatcher.GAME_CONSTANTS.CELL_SIZE);

        for (let i = 0; i < numOfCells; i++) {
            const cell = new Cell(scene, cellsPosition[i].x, cellsPosition[i].y, i, reelAssociate);
            cells.push(cell);
            container.add(cell.getContainer());
        }

        return {cells: cells, cellPositions: cellsPosition};
    }

    //CREAZIONE RULLI LINK
    static createLinkReels(scene: any, orientation: any, type: string) : LinkReel[]{
        
        let linkReels: LinkReel[] = [];
        let ReelClass: any;

        if(type === "vertical") {
            ReelClass = LinkReelVertical;
        } else if (type === "rotation") {
            ReelClass = LinkReelRotation;
        }

        for (let i = 0; i < ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_REELS; i++) {
            linkReels[i] = new ReelClass(scene, ResourcesDispatcher.GAME_CONSTANTS.linkReelsPosition[i].x, 
            ResourcesDispatcher.GAME_CONSTANTS.linkReelsPosition[i].y, i, orientation);

            scene.layerManager.gameAreaLayer.linkSymbolsContainer.add(linkReels[i].getContainer());
            scene.layerManager.gameAreaLayer.linkFrameContainer.add(linkReels[i].getFrameContainer());
            scene.layerManager.gameAreaLayer.fixedLinkCellContainer.add(linkReels[i].getAnimationsContainer());
        }

        return linkReels;
    }

    //CREAZIONE RULLI FREESPIN
    static createFreeSpinReels(scene: any, orientation: any, type: string): FreeSpinReel[] {

        let numOfReels = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_REELS;
        let reels: FreeSpinReel[] = [];

        let FreeSpinReelClass: any;

        if(type === "static") {
            FreeSpinReelClass = FreeSpinReelStatic;
        } else if (type === "dynamic") {
            FreeSpinReelClass = FreeSpinReelDynamic;
        }

        const reelsPosition = ResourcesDispatcher.GAME_CONSTANTS.reelsPosition;
        for (let i = 0; i < numOfReels; i++) {
            const reel = new FreeSpinReelClass(scene, reelsPosition[i].x, reelsPosition[i].y, i, orientation);
            
            const freeSpinCellCreation = CreationManager.createFreeSpinCells(scene, reel, reel.getContainer());

            reel.setFreeSpinCellCreation(freeSpinCellCreation)

            freeSpinCellCreation.cells.forEach((cell) => {
                cell.setFreeSpinReel(reel);
            });

            reels.push(reel);

            // Aggiungi i rulli ai container corretti
            scene.layerManager.gameAreaLayer.freeSpinSymbolsContainer.add(reel.getContainer());
        }

        return reels;
    }

    //CREAZIONE CELLE FREESPIN
    static createFreeSpinCells(scene: any, reelAssociate: any, container: any){

        const cells: FreeSpinCell[] = [];
        const numOfCells = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_CELLS_PER_REEL + ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_CELLS_PER_REEL;
        const cellsPosition = Utils.generateCellPositions(numOfCells, ResourcesDispatcher.GAME_CONSTANTS.CELL_SIZE);

        for (let i = 0; i < numOfCells; i++) {
            const cell = new FreeSpinCell(scene, cellsPosition[i].x, cellsPosition[i].y, i, reelAssociate);
            cells.push(cell);
            container.add(cell.getContainer());
        }

        return {cells: cells, cellPositions: cellsPosition};
    }

    //CREAZIONE EXPANDING WILD
    static createExpandingWild(scene: any, cellPosition: any[], index: number, reelAssociate: Reel) : Cell{
        const expanding = new Cell(scene, cellPosition[index].x, cellPosition[index].y, index, reelAssociate)
        expanding.getContainer().setVisible(false);
        expanding.setCellInfo(ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD)
        return expanding;
    }

    //CREAZIONE FONT
    static createFont(fontFamily: string){
        return new FontConfig(fontFamily);
    }
}